// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recent-games {
  background-color: var(--ion-color-tertiary);
  color: #343437;
  overflow: hidden;
}
.recent-games .button-container {
  max-width: 95%;
  margin-left: 2.5%;
  background: linear-gradient(90deg, #F47D35 0.29%, #ED1067 65.21%, #8D5EA1 208.04%, #9C4198 208.04%); /* Gradient background */
  padding: 1px; /* Padding to create space for the inner container */
  border-radius: 5px;
  display: flex;
  gap: 1px;
  flex-direction: row;
  /* Inner container to have the same background color as the parent element */
}
.recent-games .button-container .inner-container {
  padding: 2px;
  background-color: var(--ion-color-tertiary); /* Matches the background color */
  border-radius: 5px;
  width: 100%;
  display: flex;
  gap: 2px;
  flex-direction: row;
}
.recent-games .button-container .segment-button {
  width: 50%;
  background-color: var(--ion-color-tertiary);
  height: 100%;
  min-height: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.recent-games .button-container .segment-button ion-label {
  align-self: center;
  color: #FFF;
  font-size: 13px;
  font-weight: bold;
}
.recent-games .button-container .selected {
  background: linear-gradient(90deg, #F47D35 0.29%, #ED1067 65.21%, #8D5EA1 208.04%, #9C4198 208.04%);
  border-radius: 5px;
}
.recent-games .button-container .selected ion-label {
  color: #fff;
  font-weight: bold;
}
.recent-games .mobileAppTopStyle {
  margin-top: 3px;
}
.recent-games .content-container {
  background-color: var(--ion-color-tertiary);
}
.recent-games .content-container .no-games-card-container {
  display: flex;
  padding-top: -50px;
  max-width: 80%;
  margin-left: 10%;
  background-color: var(--ion-color-tertiary);
  padding: 0%;
  justify-content: center;
  overflow: hidden;
}
.recent-games .content-container .no-games-card-container .no-games-card {
  color: var(--ion-color-tertiary);
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.recent-games .content-container .no-games-card-container .no-games-card .title {
  font-weight: bold;
  text-align: center;
  color: #FFF;
}
.recent-games .content-container .no-games-card-container .no-games-card .subtitle {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  color: #FFF;
}
.recent-games .content-container .mobile-games-gallery {
  display: flex;
  flex-direction: row;
  padding-top: 0.8rem;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: var(--ion-color-tertiary);
  color: white;
}
.recent-games .content-container .mobile-games-gallery::-webkit-scrollbar {
  display: none;
}
.recent-games .content-container .mobile-games-gallery .mobile-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 10px 0px 10px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container {
  position: relative;
  min-width: 18%;
  height: 80px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .image-tile {
  min-width: 75px;
  min-height: 75px;
  border: solid 1px var(--ion-color-tertiary);
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .close-button {
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(30%, -30%);
  border: solid 1px var(--ion-color-tertiary);
  border-radius: 50%;
  background-color: #DA2086;
  padding: 2px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .image-container .hidden-button {
  position: relative;
  top: -72px;
  right: -54px;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .game-label {
  color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin: 0%;
  padding: 0%;
}
.recent-games .content-container .mobile-games-gallery .mobile-block .text-label {
  font-size: 0.7rem;
  margin: 0%;
  padding: 0%;
}

.background-fixer {
  background-color: var(--ion-color-tertiary);
}

ion-content {
  --background: black no-repeat 100% 100%;
}

.jackpot-mobile-top {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.jackpot-mobile-bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

jackpot-counter-mobile {
  position: absolute;
  z-index: 998;
  background: var(--ion-color-primary);
  color: #FFFFFF;
  font-weight: bold;
  padding: 3px 0px;
  left: 0;
  text-align: center;
  width: 100%;
  font-family: "roboto";
}

ion-icon {
  font-size: 1.5rem;
}

.jackpot-counter-top {
  top: 0;
}

.jackpot-counter-bottom {
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/games/games.component.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,cAAA;EACA,gBAAA;AACF;AACE;EACE,cAAA;EACA,iBAAA;EACA,mGAAA,EAAA,wBAAA;EACA,YAAA,EAAA,oDAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EAEA,4EAAA;AAAJ;AACI;EACE,YAAA;EACA,2CAAA,EAAA,iCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AACN;AAEI;EACE,UAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAAN;AAEM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAII;EACE,mGAAA;EACA,kBAAA;AAFN;AAIM;EACE,WAAA;EACA,iBAAA;AAFR;AAOE;EACE,eAAA;AALJ;AAOE;EACE,2CAAA;AALJ;AAOI;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,2CAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AALN;AAOM;EACE,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AALR;AAOQ;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;AALV;AAQQ;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AANV;AAWI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;AATN;AAWM;EACE,aAAA;AATR;AAYM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAVR;AAYQ;EACE,kBAAA;EACA,cAAA;EACA,YAAA;AAVV;AAYU;EACE,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAVZ;AAcU;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;EACA,2CAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAZZ;AAeU;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAbZ;AAiBQ;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;AAfV;AAkBQ;EACE,iBAAA;EAEA,UAAA;EACA,WAAA;AAjBV;;AAwBA;EACE,2CAAA;AArBF;;AAwBA;EACE,uCAAA;AArBF;;AAyBA;EACE,4BAAA;EACA,2BAAA;AAtBF;;AAwBA;EACE,+BAAA;EACA,8BAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACF,qBAAA;AArBA;;AAwBA;EACE,iBAAA;AArBF;;AAwBA;EACE,MAAA;AArBF;;AAuBA;EACE,SAAA;AApBF","sourcesContent":[".recent-games {\n  background-color: var(--ion-color-tertiary);;\n  color: #343437;\n  overflow: hidden;\n\n  .button-container {\n    max-width: 95%;\n    margin-left: 2.5%;\n    background: linear-gradient(90deg, #F47D35 0.29%, #ED1067 65.21%, #8D5EA1 208.04%, #9C4198 208.04%); /* Gradient background */\n    padding: 1px; /* Padding to create space for the inner container */\n    border-radius: 5px;\n    display: flex;\n    gap: 1px;\n    flex-direction: row;\n  \n    /* Inner container to have the same background color as the parent element */\n    .inner-container {\n      padding: 2px;\n      background-color: var(--ion-color-tertiary);; /* Matches the background color */\n      border-radius: 5px;\n      width: 100%;\n      display: flex;\n      gap: 2px;\n      flex-direction: row;\n    }\n  \n    .segment-button {\n      width: 50%;\n      background-color: var(--ion-color-tertiary);;\n      height: 100%;\n      min-height: 2rem;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n  \n      ion-label {\n        align-self: center;\n        color: #FFF;\n        font-size: 13px;\n        font-weight: bold;\n      }\n    }\n  \n    .selected {\n      background: linear-gradient(90deg, #F47D35 0.29%, #ED1067 65.21%, #8D5EA1 208.04%, #9C4198 208.04%);\n      border-radius: 5px;\n  \n      ion-label {\n        color: #fff;\n        font-weight: bold;\n      }\n    }\n  }\n  \n  .mobileAppTopStyle{\n    margin-top: 3px;\n  }\n  .content-container {\n    background-color: var(--ion-color-tertiary);;\n\n    .no-games-card-container {\n      display: flex;\n      padding-top: -50px;\n      max-width: 80%;\n      margin-left: 10%;\n      background-color: var(--ion-color-tertiary);;\n      padding: 0%;\n      justify-content: center;\n      overflow: hidden;\n\n      .no-games-card {\n        color: var(--ion-color-tertiary);;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n\n        .title {\n          font-weight: bold;\n          text-align: center;\n          color: #FFF;\n        }\n\n        .subtitle {\n          font-weight: bold;\n          text-align: center;\n          font-size: 14px;\n          color: #FFF;\n        }\n      }\n    }\n\n    .mobile-games-gallery {\n      display: flex;\n      flex-direction: row;\n      padding-top: 0.8rem;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      background-color: var(--ion-color-tertiary);;\n      color: white;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .mobile-block {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 5px 10px 0px 10px;\n\n        .image-container {\n          position: relative;\n          min-width: 18%;\n          height: 80px;\n\n          .image-tile {\n            min-width: 75px;\n            min-height: 75px;\n            border: solid 1px var(--ion-color-tertiary);;\n            border-radius: 10px;\n            background-size: cover;\n            background-repeat: no-repeat;\n            background-position: center;\n          //  position: relative;\n          }\n\n          .close-button {\n            position: absolute;\n            top: 0px;\n            right: 0px;\n            transform: translate(30%, -30%);\n            border: solid 1px var(--ion-color-tertiary);;\n            border-radius: 50%;\n            background-color: #DA2086;\n            padding: 2px;\n          }\n\n          .hidden-button {\n            position: relative;\n            top: -72px;\n            right: -54px;\n          }\n        }\n\n        .game-label {\n          color: #fff;\n          display: flex;\n          justify-content: flex-start;\n          align-items: flex-end;\n          margin: 0%;\n          padding: 0%;\n        }\n\n        .text-label {\n          font-size: 0.7rem;\n\n          margin: 0%;\n          padding: 0%;\n        }\n      }\n    }\n  }\n}\n\n.background-fixer {\n  background-color: var(--ion-color-tertiary);;\n}\n\nion-content {\n  --background: black no-repeat 100% 100%;\n}\n\n\n.jackpot-mobile-top {\n  border-top-right-radius:8px;\n  border-top-left-radius:8px;\n}\n.jackpot-mobile-bottom {\n  border-bottom-right-radius:8px;\n  border-bottom-left-radius:8px;\n}\n\njackpot-counter-mobile {\n  position: absolute;\n  z-index: 998;\n  background: var(--ion-color-primary);;\n  color: #FFFFFF;\n  font-weight: bold;\n  padding: 3px 0px;\n  left: 0;\n  text-align: center;\n  width: 100%;\nfont-family: 'roboto';\n}\n\nion-icon {\n  font-size: 1.5rem;\n}\n\n.jackpot-counter-top {\n  top: 0;\n}\n.jackpot-counter-bottom {\n  bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
